import { ComponentProps } from "react";
import dayjs from "dayjs";
import { twMerge } from "tailwind-merge";
import { ButtonV2, InputDateRHFV2, InputRHFV2, SelectRHFV2 } from "../../Atoms";
import { IGetAgendamentosProps } from "../../../types/agendamento";
import { useSchedulesFilterFormV2 } from "./useSchedulesFilterFormV2";

interface ISchedulesFilterFormV2Props extends ComponentProps<"form"> {
  isCliente: boolean;
  onFilter: (data: IGetAgendamentosProps) => void;
  onClear: () => void;
}

export const SchedulesFilterFormV2 = ({
  isCliente,
  onFilter,
  onClear,
  className,
  ...rest
}: ISchedulesFilterFormV2Props) => {
  const {
    Controller,
    control,
    handleSubmit,
    cidadeOptions,
    tipoOptions,
    statusOptions,
    handleCpf,
    handleClear,
  } = useSchedulesFilterFormV2();

  return (
    <form
      {...rest}
      onSubmit={handleSubmit(onFilter)}
      className={twMerge(
        "w-full rounded-[10px] border border-solid border-[#e5e5ea] bg-white",
        className,
      )}
    >
      <div className="hidden h-[72px] items-center justify-center bg-[#20332f] sm:flex">
        <span className="font-['Mulish'] text-2xl font-bold uppercase text-white">
          Filtro
        </span>
      </div>

      <div className="grid grid-cols-2 gap-x-4 gap-y-9 p-5 sm:grid-cols-5 sm:p-10">
        <div className="order-1 col-span-1 sm:order-1">
          <Controller
            control={control}
            name="dataInicial"
            render={({ field: { onChange, value } }) => (
              <InputDateRHFV2
                id="dataInicial"
                label="Data Inicial"
                selected={value ? dayjs(value).toDate() : null}
                onChange={(e) =>
                  onChange(e ? dayjs(e).format("YYYY-MM-DD") : "")
                }
              />
            )}
          />
        </div>

        <div className="order-2 col-span-1 sm:order-2">
          <Controller
            control={control}
            name="dataFinal"
            render={({ field: { onChange, value } }) => (
              <InputDateRHFV2
                id="dataFinal"
                label="Data Final"
                selected={value ? dayjs(value).toDate() : null}
                onChange={(e) =>
                  onChange(e ? dayjs(e).format("YYYY-MM-DD") : "")
                }
              />
            )}
          />
        </div>

        <div className="order-3 col-span-1 sm:order-3">
          <Controller
            control={control}
            name="cidade"
            render={({ field: { onChange, value } }) => (
              <SelectRHFV2
                id="cidade"
                label="Cidade"
                placeholder="Selecione"
                options={cidadeOptions}
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
              />
            )}
          />
        </div>

        <div className="order-4 col-span-1 sm:order-4">
          <Controller
            control={control}
            name="tipoAtendimento"
            render={({ field: { onChange, value } }) => (
              <SelectRHFV2
                id="tipoAtendimento"
                label="Tipo"
                placeholder="Selecione"
                options={tipoOptions}
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
              />
            )}
          />
        </div>

        <div className="order-5 col-span-2 sm:order-6 sm:col-span-1">
          <Controller
            control={control}
            name="placa"
            render={({ field }) => (
              <InputRHFV2 id="placa" label="Placa" {...field} />
            )}
          />
        </div>

        <div className="order-6 col-span-2 sm:order-5 sm:col-span-1">
          <Controller
            control={control}
            name="renavam"
            render={({ field }) => (
              <InputRHFV2 id="renavam" label="Renavam" {...field} />
            )}
          />
        </div>

        <div className="order-7 col-span-2 sm:order-7 sm:col-span-2">
          <Controller
            control={control}
            name="chassi"
            render={({ field }) => (
              <InputRHFV2 id="chassi" label="Chassi" {...field} />
            )}
          />
        </div>

        {!isCliente && (
          <div className="order-8 col-span-2 sm:order-9 sm:col-span-3">
            <Controller
              control={control}
              name="nome"
              render={({ field }) => (
                <InputRHFV2 id="nome" label="Nome" {...field} />
              )}
            />
          </div>
        )}

        {!isCliente && (
          <div className="order-9 col-span-2 sm:order-8 sm:col-span-2">
            <Controller
              control={control}
              name="cpfCnpj"
              render={({ field: { value } }) => (
                <InputRHFV2
                  id="cpfCnpj"
                  label="CPF/CNPJ"
                  maxLength={18}
                  value={value || ""}
                  onChange={(e) => handleCpf(e.target.value)}
                />
              )}
            />
          </div>
        )}

        <div className="order-10 col-span-2 sm:order-10 sm:col-span-2">
          <Controller
            control={control}
            name="statusAgendamento"
            render={({ field: { onChange, value } }) => (
              <SelectRHFV2
                id="statusAgendamento"
                label="Status"
                placeholder="Selecione"
                options={statusOptions}
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
              />
            )}
          />
        </div>

        <div className="order-11 col-span-2 flex items-center justify-center gap-6 sm:order-11 sm:col-span-2 sm:col-start-4 sm:justify-end">
          <button
            type="button"
            onClick={() => {
              handleClear();
              onClear();
            }}
            className="font-['Mulish'] text-base font-normal text-[rgba(32,51,47,0.56)]"
          >
            Limpar tudo
          </button>
          <ButtonV2 type="submit">Buscar</ButtonV2>
        </div>
      </div>
    </form>
  );
};
